import { pubSub } from '@utils/PubSub';
import { mountVueWithPinia } from '../vue/mountVue';
import AutoBundle from '../vue/Product/App-AutoBundle.vue';
import SteppedBundle from '../vue/Product/App-SteppedBundle.vue';
import SingleProduct from '../vue/Product/App-SingleProduct.vue';

export class Product extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  dataLayer() {
    window.dataLayer.push({
      event: 'product_bundle_page',
      pdp_type: 'product_bundle',
    });
  }

  mountProductCards(context) {
    const root = context.querySelector('.js-main-product') ?? false;
    if (!root) return;

    const isBundle = JSON.parse(root.dataset.bundle) ?? false;
    const isAutoBundle =
      (isBundle && JSON.parse(root.dataset.autoBundle)) ?? false;

    if (isBundle) {
      this.dataLayer();
    }

    // if {{ product.selected_or_first_available_variant.id }} returns blank
    // grab variant id from url
    const propsVariant = root.getAttribute('props-variant');
    if (propsVariant == '') {
      const params = window.location.search.split('variant=');
      let variantId = params[params.length - 1].split('&')[0];
      root.setAttribute('props-variant', variantId);
    }

    if (isAutoBundle) {
      mountVueWithPinia('.js-main-product', AutoBundle, context);
    } else if (isBundle) {
      mountVueWithPinia('.js-main-product', SteppedBundle, context);
    } else {
      mountVueWithPinia('.js-main-product', SingleProduct, context);
    }
  }
}

customElements.define('main-product', Product);
